function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Divider, HStack, ModalBody, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import GiveawayModalHeader from './GiveawayModalHeader';
import { GiveawayModalContext } from './GiveawayModalContext';
import { GiveawaySteps } from '@/types/client';
import useGiveawayStore from '@/stores/GiveawayStore';
import SettingsPanel from '../SettingsPanel';
import useIntlMemo from '@/hooks/useIntlMemo';
import { useShallow } from 'zustand/react/shallow';
var MAX_RANDOM_NUMBER = 1000000;
var MIN_RANDOM_NUMBER = 1;
var FocusedInput;
(function(FocusedInput) {
    FocusedInput["MIN"] = "MIN";
    FocusedInput["MAX"] = "MAX";
})(FocusedInput || (FocusedInput = {}));
export default function GiveawayRandomNumberStep() {
    var intl = useIntl();
    var _React_useContext = React.useContext(GiveawayModalContext), onClose = _React_useContext.onClose, setStep = _React_useContext.setStep, onComplete = _React_useContext.onComplete;
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            maxRandomNumber: state.maxRandomNumber,
            minRandomNumber: state.minRandomNumber,
            setMaxRandomNumber: state.setMaxRandomNumber,
            setMinRandomNumber: state.setMinRandomNumber
        };
    })), maxRandomNumber = _useGiveawayStore.maxRandomNumber, minRandomNumber = _useGiveawayStore.minRandomNumber, setMaxRandomNumber = _useGiveawayStore.setMaxRandomNumber, setMinRandomNumber = _useGiveawayStore.setMinRandomNumber;
    var _React_useState = _sliced_to_array(React.useState(minRandomNumber), 2), min = _React_useState[0], setMin = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(maxRandomNumber), 2), max = _React_useState1[0], setMax = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(null), 2), focusedInput = _React_useState2[0], setFocusedInput = _React_useState2[1];
    function startRandomNumberGiveaway() {
        setMinRandomNumber(min);
        setMaxRandomNumber(max);
        onClose();
        onComplete();
    }
    var isMinValid = min < max;
    var isMaxValid = max > min;
    var isMinOutOfRange = min < MIN_RANDOM_NUMBER || min > MAX_RANDOM_NUMBER;
    var isMaxOutOfRange = max < MIN_RANDOM_NUMBER || max > MAX_RANDOM_NUMBER;
    var errorMessage = useIntlMemo(function(intl) {
        if (isMinOutOfRange || isMaxOutOfRange) {
            return intl.formatMessage({
                id: "XNRtNY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Range must be between "
                    },
                    {
                        type: 1,
                        value: "min"
                    },
                    {
                        type: 0,
                        value: " and "
                    },
                    {
                        type: 1,
                        value: "max"
                    },
                    {
                        type: 0,
                        value: "."
                    }
                ]
            }, {
                min: Intl.NumberFormat().format(MIN_RANDOM_NUMBER),
                max: Intl.NumberFormat().format(MAX_RANDOM_NUMBER)
            });
        }
        if (!isMinValid && focusedInput === "MIN") {
            return intl.formatMessage({
                id: "XX0nla",
                defaultMessage: [
                    {
                        type: 0,
                        value: "The minimum must be less than the maximum "
                    },
                    {
                        type: 1,
                        value: "max"
                    },
                    {
                        type: 0,
                        value: "."
                    }
                ]
            }, {
                max: Intl.NumberFormat().format(max)
            });
        }
        if (!isMaxValid && focusedInput === "MAX") {
            return intl.formatMessage({
                id: "4UDJtM",
                defaultMessage: [
                    {
                        type: 0,
                        value: "The maximum must be greater than the minimum "
                    },
                    {
                        type: 1,
                        value: "min"
                    },
                    {
                        type: 0,
                        value: "."
                    }
                ]
            }, {
                min: Intl.NumberFormat().format(min)
            });
        }
        return null;
    }, [
        isMinValid,
        isMaxValid,
        focusedInput
    ]);
    return /*#__PURE__*/ _jsxs(ModalBody, {
        padding: 0,
        children: [
            /*#__PURE__*/ _jsx(GiveawayModalHeader, {
                title: intl.formatMessage({
                    id: "S8kqP9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Conditions"
                        }
                    ]
                }),
                onClose: onClose
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsx(Stack, {
                spacing: 6,
                padding: 6,
                children: /*#__PURE__*/ _jsx(SettingsPanel, {
                    flexDir: "column",
                    alignItems: "baseline",
                    heading: intl.formatMessage({
                        id: "H1itB8",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Random Number Range"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "G/z3co",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Select the range of numbers to choose from."
                            }
                        ]
                    }),
                    afterElementContainerProps: {
                        maxWidth: '100%'
                    },
                    afterElement: /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ _jsxs(HStack, {
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ _jsxs(NumberInput, {
                                        flex: 1,
                                        value: min,
                                        isInvalid: focusedInput === "MIN" && !isMinValid || isMinOutOfRange,
                                        onFocus: function() {
                                            return setFocusedInput("MIN");
                                        },
                                        onChange: function(_, value) {
                                            return setMin(isNaN(value) ? 0 : value);
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(NumberInputField, {}),
                                            /*#__PURE__*/ _jsxs(NumberInputStepper, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(NumberIncrementStepper, {}),
                                                    /*#__PURE__*/ _jsx(NumberDecrementStepper, {})
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "NLeFGn",
                                        defaultMessage: "to"
                                    }),
                                    /*#__PURE__*/ _jsxs(NumberInput, {
                                        flex: 1,
                                        value: max,
                                        isInvalid: focusedInput === "MAX" && !isMaxValid || isMaxOutOfRange,
                                        onFocus: function() {
                                            return setFocusedInput("MAX");
                                        },
                                        onChange: function(_, value) {
                                            return setMax(isNaN(value) ? 0 : value);
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(NumberInputField, {}),
                                            /*#__PURE__*/ _jsxs(NumberInputStepper, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(NumberIncrementStepper, {}),
                                                    /*#__PURE__*/ _jsx(NumberDecrementStepper, {})
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            errorMessage != null ? /*#__PURE__*/ _jsx(Text, {
                                color: "negative",
                                fontSize: "sm",
                                children: errorMessage
                            }) : /*#__PURE__*/ _jsx(Text, {
                                color: "success",
                                fontSize: "sm",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "hhl67L",
                                    defaultMessage: "Range is valid."
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 6,
                p: 6,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        onClick: function() {
                            return setStep(GiveawaySteps.ELIGIBILITY);
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "cyR7Kh",
                            defaultMessage: "Back"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        variant: "cta",
                        onClick: function() {
                            return startRandomNumberGiveaway();
                        },
                        isDisabled: !isMaxValid || !isMinValid || isMinOutOfRange || isMaxOutOfRange,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "JXdbo8",
                            defaultMessage: "Done"
                        })
                    })
                ]
            })
        ]
    });
}
